import React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeChunkRecovery } from 'utils/chunkRecovery';
import { App } from './App';

// Initialize chunk recovery system for handling Vite preload errors and errors after deployment
initializeChunkRecovery();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
